import { BaseApi } from '@/main/baseApi';

import { API_ND_AREA, NAME } from './constants';

export type FastPracovnikSelect = {
	OsobniCis?: string;
	PracovnikOzn?: string;
	ProvozovnaId?: number;
	PracovnikId?: number;
	PracovnikText?: string;
	ProvozovnaIdText?: number;
};

class PracovnikProvider extends BaseApi {
	constructor() {
		super(API_ND_AREA, NAME);
	}

	async sendReminders(ID: any) {
		return this.post(`/${API_ND_AREA}/${NAME}/SendReminders?ID=${ID}`);
	}
}

export const apiProvider = new PracovnikProvider();
